
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import SubscriptionErrorBanner from '../ui/SubscriptionErrorBanner';
import ImpersonationBanner from '../admin/ImpersonationBanner';
import { useAuth } from '../../hooks/useAuth';

const MainLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { user } = useAuth();
  const location = useLocation();
  
  const isConversationsPage = location.pathname === '/conversations';
  const isSuperAdmin = user?.type === 'super_admin';

  return (
    <div className="flex h-screen dark:bg-background bg-light-background dark:text-text-primary text-light-text-primary">
      <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header onMenuClick={() => setIsSidebarOpen(true)} />
        {/* Show impersonation banner for super admins when managing a tenant */}
        {isSuperAdmin && <ImpersonationBanner />}
        <SubscriptionErrorBanner />
        <main className={`flex-1 flex flex-col dark:bg-background bg-light-background ${
          isConversationsPage 
            ? 'overflow-hidden' 
            : 'overflow-x-hidden overflow-y-auto px-4 sm:px-6 lg:px-8 pt-4 sm:pt-6 lg:pt-8 pb-0'
        }`}>
          {children}
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
